import { render } from "./EditFeaturesModals.vue?vue&type=template&id=523f5806"
import script from "./EditFeaturesModals.vue?vue&type=script&lang=js"
export * from "./EditFeaturesModals.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "523f5806"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('523f5806', script)) {
    api.reload('523f5806', script)
  }
  
  module.hot.accept("./EditFeaturesModals.vue?vue&type=template&id=523f5806", () => {
    api.rerender('523f5806', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/EditFeaturesModals.vue"

export default script